<template>
  <div class="site-box">
    <div class="heading" @click="toggle">
      <span class="image-container">
        <img class="site-image" :src="image" />
      </span>
      <div class="heading-content">
        <span class="site-details">{{ siteType }} :</span>
        <span class="site-name">{{ data.name }}</span>
      </div>
      <span :class="['icon-container', { reversed: opened }]">
        <i class="icon-arrow_down" />
      </span>
    </div>
    <template v-if="opened">
      <TransportSummary
        v-for="(transport, idx) in transports"
        :key="idx"
        :idxs="{ siteIdx, transportIdx: idx }"
        :transport="transport"
        :active-section="activeSection"
      />
    </template>
  </div>
</template>

<script>
import assetProvider from '@/pure/assetProvider';
import TransportSummary from '@/components/Export/pure/TransportSummary';

export default {
  components: { TransportSummary },
  props: ['data', 'siteIdx', 'activeSection'],

  data() {
    return {
      opened: false,
    };
  },

  computed: {
    image() {
      return assetProvider.poiHome;
    },

    siteType() {
      return this.data.type === 1 ? this.$t('CurrentSiteName') : this.$t('sections.mainSynthesis');
    },

    transports() {
      return this.data.transports;
    },
  },

  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.heading {
  display: flex;
  height: 76px;
  border-bottom: 1px solid #e3e3e3;
}

.heading-content {
  flex: 1;
  box-sizing: border-box;
  padding-left: 12px;
  cursor: pointer;

  .site-details {
    font-size: 14px;
    display: block;
  }

  .site-name {
    font-size: 16px;
    font-weight: 900;
    color: #3c3c3b;
  }
}

.icon-container {
  display: flex;

  &.reversed {
    transform: rotate(180deg);
  }
}

.image-container {
  width: 18px;

  img {
    width: 100%;
    height: auto;
  }
}
</style>
